// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let AgentInfo = require("../../common/Agent/AgentInfo.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AnonymousAgentInfo = require("../../common/Agent/AnonymousAgentInfo.bs.js");
let ContactAgentButton = require("../../common/Agent/ContactAgentButton.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyPage__NextShowing = require("../../propertyPage/PropertyPage__NextShowing.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let PropertyWizardRelay__Preview__Shared = require("./PropertyWizardRelay__Preview__Shared.bs.js");
let PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
let PropertyWizardRelay__Preview__Sidecard__MlsInfo = require("./PropertyWizardRelay__Preview__Sidecard__MlsInfo.bs.js");
let PropertyWizardRelayPreviewSidecard_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecard_formState_graphql.bs.js");
let PropertyWizardRelayPreviewSidecard_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecard_localDraft_graphql.bs.js");
let PropertyWizardRelayPreviewSidecard_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewSidecard_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayPreviewSidecard_localDraft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayPreviewSidecard_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, fRef);
}

let DisplayHelpersFragment_forSalePropertyAgentVisibilityReason_decode = PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.Utils.forSalePropertyAgentVisibilityReason_decode;

let DisplayHelpersFragment_forSalePropertyAgentVisibilityReason_fromString = PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.Utils.forSalePropertyAgentVisibilityReason_fromString;

let DisplayHelpersFragment_membershipStatusV5_decode = PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.Utils.membershipStatusV5_decode;

let DisplayHelpersFragment_membershipStatusV5_fromString = PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.Utils.membershipStatusV5_fromString;

let DisplayHelpersFragment = {
  forSalePropertyAgentVisibilityReason_decode: DisplayHelpersFragment_forSalePropertyAgentVisibilityReason_decode,
  forSalePropertyAgentVisibilityReason_fromString: DisplayHelpersFragment_forSalePropertyAgentVisibilityReason_fromString,
  membershipStatusV5_decode: DisplayHelpersFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: DisplayHelpersFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = PropertyWizardRelayPreviewSidecard_formState_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, fRef);
}

let FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function PropertyWizardRelay__Preview__Sidecard$Body(props) {
  let mlsErrorMessages = props.mlsErrorMessages;
  let propertyType = props.propertyType;
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, props.displayHelpers);
  let showings = Stdlib_Option.getOr(displayHelpers.showings, []).map(x => x.fragmentRefs);
  let timezone = Stdlib_Option.map(props.timezone, DateFnsTz.Timezone.make);
  let tmp;
  tmp = propertyType === "FOR_SALE" && timezone !== undefined ? JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(PropertyPage__NextShowing.make, {
        showings: showings,
        timezone: Primitive_option.valFromOption(timezone)
      }),
      className: "pb-4 border-b-gray-200 border-b"
    }) : null;
  let tmp$1;
  if (mlsErrorMessages !== undefined) {
    tmp$1 = JsxRuntime.jsx("div", {
      children: mlsErrorMessages,
      className: "pb-4 border-b-gray-200 border-b"
    });
  } else {
    let match = displayHelpers.mlsPlan;
    tmp$1 = match !== undefined ? JsxRuntime.jsx(PropertyWizardRelay__Preview__Sidecard__MlsInfo.make, {
        mlsPlan: match.fragmentRefs,
        propertyType: propertyType,
        className: "pb-4 border-b-gray-200 border-b"
      }) : null;
  }
  let match$1 = displayHelpers.agentV2;
  let tmp$2;
  if (match$1 !== undefined) {
    switch (match$1.__typename) {
      case "HiddenPropertyPreviewAgent" :
        let match$2 = match$1.membershipStatus;
        tmp$2 = match$2 === "TERMINATED" ? JsxRuntime.jsx(AnonymousAgentInfo.make, {
            size: "medium",
            isTerminated: true
          }) : JsxRuntime.jsx(AnonymousAgentInfo.make, {
            size: "medium"
          });
        break;
      case "VisiblePropertyPreviewAgent" :
        let exit = 0;
        let tmp$3 = match$1.visibilityRule;
        if (tmp$3 === "OWN_ANONYMOUS") {
          tmp$2 = JsxRuntime.jsx(AnonymousAgentInfo.make, {
            size: "medium"
          });
        } else {
          exit = 1;
        }
        if (exit === 1) {
          tmp$2 = JsxRuntime.jsx(AgentInfo.make, {
            agent: match$1.agent.fragmentRefs,
            size: "medium"
          });
        }
        break;
      case "__unselected" :
        tmp$2 = UnselectedUnionMemberError.raise(`Unselected property preview agent ` + match$1._0);
        break;
    }
  } else {
    tmp$2 = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      tmp,
      tmp$1,
      tmp$2
    ],
    className: "px-4 flex flex-col gap-4 py-4"
  });
}

let Body = {
  make: PropertyWizardRelay__Preview__Sidecard$Body
};

function PropertyWizardRelay__Preview__Sidecard(props) {
  let displayHelpers = props.displayHelpers;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_localDraft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_formState_graphql.node, convertFragment$2, props.formState);
  let displayHelpers$1 = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecard_displayHelpers_graphql.node, convertFragment$1, displayHelpers);
  let onMlsAtValid = PropertyWizardFormRelay__Validators__MLSTiming.OnMLSAt.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let mlsListingTypeValid = PropertyWizardFormRelay__Validators__MLSTiming.MLSListingType.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let mlsPreviewErrorMessages = PropertyWizardRelay__Preview__Shared.getMlsPreviewErrorMessages(mlsListingTypeValid, onMlsAtValid, props.onEditForm);
  let match = displayHelpers$1.agentV2;
  let tmp;
  if (match !== undefined) {
    switch (match.__typename) {
      case "HiddenPropertyPreviewAgent" :
        tmp = null;
        break;
      case "VisiblePropertyPreviewAgent" :
        tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ContactAgentButton.make, {
              agent: match.agent.fragmentRefs,
              fullWidth: true,
              variant: "Secondary",
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(IconV5.make, {
                    icon: "comment"
                  }),
                  "Contact agent"
                ],
                className: "flex items-center gap-2"
              })
            }),
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              disabled: true,
              size: "small",
              icon: "share",
              children: "Share with client"
            })
          ],
          className: "my-6 px-4 grid grid-cols-1 xl:grid-cols-2 gap-2"
        });
        break;
      case "__unselected" :
        tmp = UnselectedUnionMemberError.raise(`Unselected property preview agent ` + match._0);
        break;
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(PropertyWizardRelay__Preview__Sidecard$Body, {
        displayHelpers: displayHelpers,
        propertyType: draft.draftProperty.propertyType,
        timezone: draft.timeZone,
        mlsErrorMessages: mlsPreviewErrorMessages
      }),
      JsxRuntime.jsx("div", {
        children: tmp,
        className: "bg-gray-100 border-t border-gray-200 rounded-b-md"
      })
    ],
    className: "border border-gray-200 rounded-md bg-white flex flex-col sticky top-16 max-w-sm"
  });
}

let Validators;

let Shared;

let make = PropertyWizardRelay__Preview__Sidecard;

exports.Validators = Validators;
exports.Shared = Shared;
exports.DraftFragment = DraftFragment;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.FormStateFragment = FormStateFragment;
exports.Body = Body;
exports.make = make;
/* IconV5 Not a pure module */
